import React from 'react';
import './PreprodBanner.css';

const PreprodBanner: React.FC = () => {
  const env = process.env.REACT_APP_ENV;

  if (env !== 'preprod' && env !== 'development' && env !== 'staging') {
    return null;
  }

  const getBannerText = () => {
    if (env === 'preprod') {
      return '⚠️ AMBIENTE DE PRÉ-PRODUÇÃO ⚠️';
    }
    if (env === 'development') {
      return 'AMBIENTE DE DESENVOLVIMENTO';
    }
    if (env === 'staging') {
      return 'Ambiente de staging';
    }
    return '';
  };

  return (
    <>
      <div className={`env-banner ${env}`}>
        {getBannerText()}
      </div>
      <div className="env-banner-spacer" />
    </>
  );
};

export default PreprodBanner;
